// Carry Roll BenchmarkOverlay — optimal-range reference overlay (10.2).

import { Check, X } from 'lucide-react';
import { useStore } from '../../store';
import { radToDeg } from '@carry-roll/shared-logic';
import { findReference } from '@carry-roll/shared-logic';

export function BenchmarkOverlay() {
  const launch = useStore((s) => s.request.launch);
  const clubCategory = useStore((s) => s.request.club?.category);

  if (!clubCategory) return null;
  const ref = findReference(clubCategory, launch.ballSpeed);
  if (!ref) return null;

  const launchDeg = radToDeg(launch.launchAngle);
  const launchInRange = launchDeg >= ref.launchAngleDeg[0] && launchDeg <= ref.launchAngleDeg[1];
  const spinInRange = launch.spinRpm >= ref.spinRpm[0] && launch.spinRpm <= ref.spinRpm[1];

  return (
    <div data-testid="benchmark-overlay" className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
      <span>Optimal range for {clubCategory}: launch {ref.launchAngleDeg[0]}–{ref.launchAngleDeg[1]}° </span>
      <span style={{ color: launchInRange ? 'var(--color-success)' : 'var(--color-warn)' }}>
        ({launchInRange ? <Check size={11} aria-hidden="true" style={{ verticalAlign: 'middle' }} /> : <X size={11} aria-hidden="true" style={{ verticalAlign: 'middle' }} />} {launchDeg.toFixed(1)}°)
      </span>
      <span>, spin {ref.spinRpm[0]}–{ref.spinRpm[1]} rpm </span>
      <span style={{ color: spinInRange ? 'var(--color-success)' : 'var(--color-warn)' }}>
        ({spinInRange ? <Check size={11} aria-hidden="true" style={{ verticalAlign: 'middle' }} /> : <X size={11} aria-hidden="true" style={{ verticalAlign: 'middle' }} />} {Math.round(launch.spinRpm)})
      </span>
    </div>
  );
}
